/* eslint-disable */
import { DateTime } from 'luxon';

/* Get the current instant */
const now = DateTime.now();
export const notifications = [
    {
        id         : '493190c9-5b61-4912-afe5-78c21f1044d7',
        icon       : 'heroicons_mini:star',
        title      : 'Application Submitted',
        description: 'Your submission has been accepted',
        // time       : moment().subtract(25, 'minutes').toISOString(), // 25 minutes ago
        time       : now.minus({ minute: 25 }).toISO(), // 25 minutes ago
        read       : false
    },
    {
        id         : '6e3e97e5-effc-4fb7-b730-52a151f0b641',
        image      : 'images/avatars/male-04.jpg',
        description: '<strong>Leo Gill</strong> assigned you the <em>Top Secret Project</em> application',
        time       : now.minus({ minute: 50 }).toISO(), // 50 minutes ago
        read       : true,
        link       : '/dashboards/project',
        useRouter  : true
    }
];
